import { createContext } from 'react';
import type { ContexteAppelValeur } from './types';

export const ContexteAppel = createContext<ContexteAppelValeur | null>(null);
